import styled from '@emotion/styled'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const ImpactChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`

export const StyledChip = styled(Chip)`
  background-color: ${colors.interactive.secondaryEnabled};
  border-radius: 100px;
  ${typography.baseline.regularSans}
  font-size: 13px;
  line-height: 18px;
  height: inherit;
  padding: 9px 4px;
  margin-right: 0;

  &.MuiChip-outlined {
    background-color: transparent;
    border-color: ${colors.interactive.secondaryEnabled};
    color: ${colors.text.primary};
  }

  &.MuiChip-filled {
    background-color: ${colors.interactive.secondaryEnabled};
    color: ${colors.text.primary};
  }

  & .MuiChip-deleteIcon {
    font-size: 18px;
  }
`

export const ChipInput = styled('input')`
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  width: 80px;
  &:focus {
    outline: none;
  }
`

export const AddChipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${colors.interactive.secondaryEnabled};
  border-radius: 100px;
  padding: 4px 12px;
  height: 40px;
`

export const ImpactAutoComplete = styled(Autocomplete)`
  width: 100%;
  height: 100%;

  & .MuiInputBase-root {
    ${typography.baseline.regularSans}
    font-size: 13px;
    line-height: 18px;
  }
`
export const AutoCompleteTextField = styled(TextField)`
  min-width: 200px;
  padding: 2px 8px;
  height: 40px;

  & input {
    padding: 0;
  }
  & .MuiAutocomplete-clearIndicator svg {
    font-size: 13px;
  }
`

export const StyledMenuItem = styled.li`
  ${typography.baseline.regularSans}
  font-size: 13px;
  line-height: 18px;
`
